import React, {Fragment} from 'react';
import {Button, DateField, Show, TextField, useTranslate} from 'react-admin';
import {Grid, GridShowLayout} from '../../components/wrapper';
import {Dialog, DialogContent, DialogTitle, makeStyles, Typography} from "@material-ui/core";
import MT940FileRecordList from "../mt940FileRecords/MT940FileRecordList";
import IconCreate from "@material-ui/icons/Create";
import {Link} from 'react-router-dom';
import {Route} from 'react-router';
import MT940FileEdit from "./MT940FileEdit";


const useStyles = makeStyles({
    titles: {
        marginTop: 10,
        marginBottom: 20
    },
    show: {
        marginBottom: 24
    },
    list: {
        marginBottom: 24
    }
});

const EditMT940FileButton = props => (
    <Button
        component={Link}
        to={{
            pathname: `/mt940Files/${props.id}/show/editFile`,
            state: {skipFormReset: true}
        }}
        label={'ra.action.edit'}
    >
        <IconCreate/>
    </Button>
);

const MT940FileShow = props => {

    const translate = useTranslate();

    const fileId = props.id;

    const classes = useStyles();

    const handleClose = () => {
        this.props.goBack();
    };

    return (
        <Fragment>
            <Show {...props} className={classes.show}>
                <GridShowLayout>
                    <Grid container>
                        <Grid item xs>
                            <TextField source="id"/>
                            <DateField source="creationDateTime" showTime={true}/>
                            <DateField source="statusDateTime" showTime={true}/>
                            <TextField source="status"/>
                            <EditMT940FileButton id={fileId}/>
                        </Grid>
                        <Grid item xs>
                            <TextField source="sourceFilePath"/>
                            <TextField source="targetFilePath"/>
                            <TextField source="fileName"/>
                            <TextField source="statusText"/>
                        </Grid>
                    </Grid>
                </GridShowLayout>
            </Show>
            <Typography className={classes.titles} variant="h5">
                {translate('resources.mt940Files.titles.fileRecords')}
            </Typography>
            <MT940FileRecordList
                perPage={5}
                {...props}
                title=" "
                basePath={`/mt940Files/${fileId}/show`}
                resource={'mt940FileRecords'}
                className={classes.list}
                filter={{
                    id: props.id
                }}
            />
            <Route path="/mt940Files/:fileId/show/editFile">
                {({match}) => {
                    const isMatch = !!(
                        match &&
                        match.params &&
                        match.params.fileId === fileId
                    );
                    return (
                        <Dialog fullWidth open={isMatch} onClose={handleClose}>
                            <DialogTitle>{translate('resources.mt940Files.labels.editMT940File')}</DialogTitle>
                            <DialogContent style={{paddingLeft: 24, paddingRight: 24}}>
                                {isMatch && (
                                    <MT940FileEdit
                                        {...props}
                                        fileId={fileId}
                                        onCancel={handleClose}
                                    />
                                )}
                            </DialogContent>
                        </Dialog>
                    );
                }}
            </Route>
        </Fragment>
    );
};

export default MT940FileShow;
